<template>
  <v-date-picker :value="value === undefined || value === null ? null : { start: moment(value.start).format('YYYY/MM/DD'), end: moment(value.end).format('YYYY/MM/DD') }" @input="$emit('input', $event === undefined || $event === null ? null : {start: moment($event.start).format('YYYY-MM-DD'), end: moment($event.end).format('YYYY-MM-DD')})" is-range >
    <template v-slot="{ inputValue, inputEvents }">
      <div style='display: inline-block'>
	<input :value="inputValue.start" v-on="inputEvents.start" style='max-width: 100px; text-align: center; display: inline-block' :required="required" />
	<input :value="inputValue.end" v-on="inputEvents.end" style='max-width: 100px; text-align: center; display: inline-block' :required="required" />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
import VDatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: "entry",
    components : {
	VDatePicker
    },
    props : {
	value :  { type: Object },
	required : { type: Boolean }
    }
}
</script>
